/**
 * Changes font color of whole chart
 * @param {Object} chart ChartJS instance
 * @param {String} color
 */
export function SetFontColor(chart, color) {
	let changeItemColor = (item) => {
		item.scaleLabel.fontColor = color;
		item.ticks.fontColor = color;
		item.ticks.minor.fontColor = color;
		item.ticks.major.fontColor = color;
	};
	chart.options.scales.xAxes.forEach((item) => changeItemColor(item));
	chart.options.scales.yAxes.forEach((item) => changeItemColor(item));
	chart.options.legend.labels.fontColor = color;
	chart.update();
}

/**
 * Sets color of all grid lines
 * @param {Object} chart ChartJS instance
 * @param {String} color
 */
export function SetGridLinesColor(chart, color) {
	let changeItemColor = (item) => {
		item.gridLines.color = color;
	};
	chart.options.scales.xAxes.forEach((item) => changeItemColor(item));
	chart.options.scales.yAxes.forEach((item) => changeItemColor(item));
	chart.update();
}

/**
 * Sets visibility of horizontal and vertical gridLines
 * @param {Object} chart ChartJS instance
 * @param {Boolean} horizontalVisibility
 * @param {Boolean} verticalVisibility
 */
export function SetGridLinesVisibility(chart, horizontalVisibility, verticalVisibility) {
	let changeVisibility = (axis, visible) => {
		axis.gridLines.display = visible;
	};
	chart.options.scales.xAxes.forEach((axis) => changeVisibility(axis, verticalVisibility));
	chart.options.scales.yAxes.forEach((axis) => changeVisibility(axis, horizontalVisibility));
	chart.update();
}

/**
 * Sets labels on X- and Y-Axes.
 * If the label string is empty or null, it will be hidden.
 * @param {Object} chart ChartJS instance
 * @param {String} xAxisLabel
 * @param {String} yAxisLabel
 */
export function SetAxesLabel(chart, xAxisLabel, yAxisLabel) {
	let changeLabel = (axis, label) => {
		if (!axis.scaleLabel)
			axis.scaleLabel = {};

		axis.scaleLabel.display = label ? true : false;
		axis.scaleLabel.labelString = label;
	};
	chart.options.scales.xAxes.forEach((axis) => changeLabel(axis, xAxisLabel));
	chart.options.scales.yAxes.forEach((axis) => changeLabel(axis, yAxisLabel));
	chart.update();
}

/**
 * Sets prefixes and suffixes to y-Axis numbering
 * @param {Object} chart ChartJS instance
 * @param {String} prefix
 * @param {String} suffix
 */
export function SetYAxesPrefixAndSuffix(chart, prefix, suffix) {
	let change = (axis, prefix, suffix) => {
		if (!axis.ticks)
			axis.ticks = {};

		axis.ticks.callback = function (value, index, values) {
			return prefix + value + suffix;
		};
	};
	chart.options.scales.yAxes.forEach((axis) => change(axis, prefix, suffix));
	chart.update();
}

/**
 * Sets legend position (or hides it)
 * @param {Object} chart ChartJS instance
 * @param {String} position 'top', 'bottom', 'left', 'right' or 'hidden'
 */
export function SetLegendPosition(chart, position) {
	chart.options.legend.display = (!position | position == "hidden") ? false : true;
	if (position)
		chart.options.legend.position = position;
	chart.update();
}

/**
 * Sets whole chart config (defined in fieldset chart_config) to passed chart instance
 * @param {Object} chart ChartJS instance
 * @param {Object} chartConfig
 */
export function SetChartConfig(chart, chartConfig) {
	Chart.defaults.global.defaultFontFamily = "PoppinsRegular";
	Chart.defaults.global.defaultFontColor = "#d3d3d3";
	Chart.defaults.global.defaultFontSize = 14;

	if (chartConfig.fontColor)
		SetFontColor(chart, chartConfig.fontColor);

	if (chartConfig.gridLinesColor)
		SetGridLinesColor(chart, chartConfig.gridLinesColor);

	SetGridLinesVisibility(chart, chartConfig.gridLinesHorizontalEnabled, chartConfig.gridLinesVerticalEnabled);
	SetAxesLabel(chart, chartConfig.xAxisLabel, chartConfig.yAxisLabel);
	SetYAxesPrefixAndSuffix(chart, chartConfig.yAxisValuePrefix, chartConfig.yAxisValueSuffix);
	SetLegendPosition(chart, chartConfig.legendPosition ? chartConfig.legendPosition.value : null);
}